import { render, staticRenderFns } from "./PhotoMain.vue?vue&type=template&id=3459e5b7&"
import script from "./PhotoMain.vue?vue&type=script&lang=ts&"
export * from "./PhotoMain.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoMain.vue?vue&type=style&index=0&id=3459e5b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports